import type { CameraInfo } from '@scaleaq/sitecontrol-lib';

import { sortByName } from '@/utils/sort.ts';

import type { CameraWidgetConfig } from './cameraSelector/cameraWidgetConfig.types.ts';

type ResolvedCameraWidgetSelection = {
  camera: CameraInfo | undefined;
  siblingCameras: CameraInfo[];
};

export const resolveCameraWidgetSelection = (
  cameras: readonly CameraInfo[] | undefined,
  config: CameraWidgetConfig
): ResolvedCameraWidgetSelection => {
  if (!cameras?.length) return { camera: undefined, siblingCameras: [] };

  const exactCamera = cameras.find(camera => camera.id === config.camera.id);
  const parentId = exactCamera?.parentId ?? config.camera.parentId;
  const siblingCameras = parentId
    ? sortByName(cameras.filter(camera => camera.parentId === parentId))
    : [];

  return {
    camera: exactCamera ?? siblingCameras[0],
    siblingCameras,
  };
};
